import Game from "./Game";

(()=>{
    const game = new Game();

    // Listen for window resize and keep the canvas set to full screen.
    window.onresize = function () {
        game.onResize(window);
    };

    // Initialize things when the window has finished loading.
    window.onload = function () {
        game.onLoad(window, document);
    };

    // Save the game when the user leaves the page.
    window.onbeforeunload = function () {
        game.onUnload();
    };
    
})();